/* Language changes within one origin remain native. A populated cart must not
 * leave its origin until an independently verified transfer is available. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var origins = ['https://naturlabs.cz', 'https://naturlabs.eu'];

  function resolveTarget(origin, language, alternates) {
    if (origins.indexOf(origin) < 0) return null;
    var candidates = alternates.filter(function (link) {
      return link.language.toLowerCase() === language.toLowerCase() + '-cz';
    });
    if (!candidates.length) candidates = alternates.filter(function (link) {
      return link.language.toLowerCase() === language.toLowerCase();
    });
    if (candidates.length !== 1) return null;
    try {
      var target = new URL(candidates[0].href);
      if (origins.indexOf(target.origin) < 0 || target.username || target.password || target.search || target.hash) return null;
      return target.href;
    } catch (_) {
      return null;
    }
  }
  function classify(origin, language, alternates) {
    var target = resolveTarget(origin, language, alternates);
    return !target ? 'unknown' : new URL(target).origin === origin ? 'same-origin' : 'cross-origin';
  }

  function canResume(cart) {
    return !!cart && cart.item_count === 0 && Array.isArray(cart.items) && cart.items.length === 0 && !cart.note &&
      (cart.attributes == null || (typeof cart.attributes === 'object' && !Array.isArray(cart.attributes) && Object.keys(cart.attributes).every(function (key) { return key === 'globe_DeliveryMethod' && cart.attributes[key] === 'home'; })));
  }

  function message(locale, reason) {
    var copy = {
      cs: {
        nonempty: 'Košík se nepodařilo bezpečně převést. Vaše položky zůstaly v původní jazykové verzi. Po uložení změn to prosím zkuste znovu.',
        error: 'Košík se nepodařilo ověřit. Zůstáváte v této jazykové verzi. Zkuste změnu jazyka znovu.',
        saved: 'Přepnutí jazyka se nepodařilo dokončit. Obnovte stránku a před dalším pokusem zkontrolujte košík v obou jazykových verzích.'
      },
      en: {
        nonempty: 'Your basket could not be transferred safely. Your items remain in the original language version. Please try again after your changes are saved.',
        error: 'Your basket could not be checked. You are staying in this language version. Please try changing language again.',
        saved: 'The language switch could not be completed. Refresh the page and check your basket in both language versions before trying again.'
      },
      de: {
        nonempty: 'Ihr Warenkorb konnte nicht sicher übertragen werden. Ihre Artikel bleiben in der ursprünglichen Sprachversion. Versuchen Sie es erneut, sobald Ihre Änderungen gespeichert sind.',
        error: 'Ihr Warenkorb konnte nicht geprüft werden. Sie bleiben in dieser Sprachversion. Bitte versuchen Sie den Sprachwechsel erneut.',
        saved: 'Der Sprachwechsel konnte nicht abgeschlossen werden. Laden Sie die Seite neu und prüfen Sie vor einem weiteren Versuch Ihren Warenkorb in beiden Sprachversionen.'
      }
    };
    return (copy[locale] || copy.cs)[reason === 'destination-saved' ? 'saved' : reason === 'error' ? 'error' : 'nonempty'];
  }

  function install(win) {
    if (origins.indexOf(win.location.origin) < 0) return;
    var pending = new WeakSet();
    var resumed = new WeakSet();
    win.document.addEventListener('submit', async function (event) {
      var form = event.target;
      if (!form || !form.matches('form.nl-lang__form')) return;
      if (resumed.has(form)) {
        resumed.delete(form);
        return;
      }
      if (event.defaultPrevented) return;
      var input = form.querySelector('input[name="language_code"]');
      if (!input) return;
      var current = (win.document.documentElement.lang || 'cs').toLowerCase().split('-')[0];
      if (input.value.toLowerCase() === current) return;
      var alternates = Array.from(win.document.querySelectorAll('link[rel="alternate"][hreflang]')).map(function (link) {
        return { language: link.hreflang, href: link.href };
      });
      if (classify(win.location.origin, input.value, alternates) === 'same-origin') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pending.has(form)) return;
      pending.add(form);
      var busy = form.getAttribute('aria-busy');
      form.setAttribute('aria-busy', 'true');
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 8000);
      var transferAttempted = false, moved = false;
      try {
        var sameTab = win.NLLanguageSameTab;
        var target = resolveTarget(win.location.origin, input.value, alternates);
        if (!win.NL || !win.NL.cart || typeof win.NL.cart.whenIdle !== 'function') throw new Error('Cart queue unavailable');
        await Promise.race([
          win.NL.cart.whenIdle(),
          new Promise(function (_resolve, reject) {
            controller.signal.addEventListener('abort', function () { reject(new Error('Cart queue timeout')); }, { once: true });
          })
        ]);
        if (controller.signal.aborted) throw new Error('Cart queue timeout');
        var route = win.Shopify && win.Shopify.routes && win.Shopify.routes.root || '/';
        var endpoint = new URL(route + 'cart.js', win.location.origin);
        if (endpoint.origin !== win.location.origin) throw new Error('Invalid cart origin');
        var response = await win.fetch(endpoint.href, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        var cart = await response.json();
        if (!canResume(cart)) {
          if (!sameTab || !target || typeof sameTab.move !== 'function') throw new Error('Same-tab basket transfer unavailable');
          clearTimeout(timeout);
          transferAttempted = true;
          await sameTab.move(cart, target);
          moved = true;
          return;
        }
        resumed.add(form);
        form.requestSubmit(event.submitter || undefined);
      } catch (error) {
        win.alert(message(current, moved || (error && error.reason === 'destination-saved') ? 'destination-saved' : transferAttempted ? 'nonempty' : 'error'));
      } finally {
        resumed.delete(form);
        clearTimeout(timeout);
        pending.delete(form);
        if (busy === null) form.removeAttribute('aria-busy');
        else form.setAttribute('aria-busy', busy);
      }
    }, true);
    win.document.querySelectorAll('button[data-nl-language-cart-locked]').forEach(function (button) {
      button.disabled = false;
    });
  }

  return { classify: classify, resolveTarget: resolveTarget, canResume: canResume, message: message, install: install };
});
